<template>
  <div>
    <kst-output print-mode field="SONumber" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="InvoiceDate" :data="data" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../InvoiceCatalog.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>